import store from '@/store'
import checkRoles from '@/utils/permissions'

import Vue from 'vue'
import VueRouter from 'vue-router'
import FilteredResultsDashboard from '@/views/FilteredResultsDashboard.vue'
import ClientOT from '@/components/OT/ClientOT/ClientOT.vue'
import ConfirmChange from '@/components/OT/ClientOT/ConfirmChange.vue'
import ResultadoPagoOT from '@/views/ResultadoPagoOT.vue'
import Dashboard from '../views/Dashboard.vue'
import AskParts from '../views/RequestParts/AskParts.vue'
import RequestedPartsView from '../views/RequestParts/RequestedPartsView.vue'
import LoginView from '../views/LoginView.vue'
import InventarioView from '../views/Inventario/InventoryView.vue'
import MovimientosManualesView from '../views/Inventario/MovimientosManualesView.vue'
import IngresoInventarioView from '../views/Inventario/IngresoInventarioView.vue'
import Parts from '../views/Inventario/Parts.vue'
import CreateOTView from '../views/OTBackoffice/CreateOTView.vue'
import ListOTView from '../views/OTBackoffice/ListOTView.vue'
import ViewOTView from '../views/OTBackoffice/ViewOTView.vue'
// import OTView from '../views/OTView.vue';
// import AssignList from '../views/AssignOT/AssignList.vue';
// import DiagnoseOT from '../views/DiagnoseOT/DiagnoseOT.vue';
// import AssignTecnicoView from '../views/AssignTecnicoView.vue';
// import Bodega from '../views/Bodega.vue';
import ExcepcionesView from '../views/ExcepcionesView.vue'
import ClientOTView from '../views/ClientOTView.vue'
import Preingreso from '../components/OT/PreIngresoCliente/PreIngreso.vue'
import SalesOpportunityView from '../views/SalesOpportunityView.vue'
import ExceptionsOV from '../views/ExceptionsOV.vue'
import OVDetailView from '../views/OVBackoffice/OVDetailView.vue'
import PreIngressRegions from '../components/OT/PreIngresoCliente/PreIngressRegions.vue'
import AddQuoteClientView from '../components/Quotations/AddQuoteClientView.vue'
import AddOportunityClientView from '../components/SalesOpportunity/AddOportunityClientView.vue'
import HistorialPiezaView from '../views/HistorialPiezaView.vue'
import SummaryReport from '../views/Reports/SummaryReport.vue'
import UserReport from '../views/Reports/UserReport.vue'

Vue.use(VueRouter)

const dashboardRoles = [
  'Administrativo',
  'Gerencia',
  'Bodega',
  'Supervisor',
  'Técnico',
  'Ventas',
]

export const routes = [
  // Públicas
  {
    path: '/login',
    component: LoginView,
    meta: {
      isPublic: true,
    },
    children: [
      {
        path: '',
        name: 'Login',
        component: () => import('@/components/auth/Login.vue'),
        meta: {
          isPublic: true,
          fullScreen: true,
          menu: false, // define si va en menú lateral
          ownCard: true,
        },
      },
      {
        path: 'retail-register',
        name: 'Registro Retail',
        component: () => import('@/components/auth/RetailRegister.vue'),
        meta: {
          isPublic: true,
          fullScreen: true,
          menu: false,
        },
      },
      {
        path: 'retail-reset-password',
        name: 'Reiniciar Contraseña Retail',
        component: () => import('@/components/auth/RetailResetPassword.vue'),
        meta: {
          isPublic: true,
          fullScreen: true,
          menu: false,
        },
      },
      // SILL-1552 — Recuperación de contraseña de Center. El back arma el link
      // del correo con la ruta absoluta `/recuperar-clave/confirmar`.
      {
        path: '/recuperar-clave',
        name: 'Recuperar Clave',
        component: () => import('@/components/auth/RecuperarClave.vue'),
        meta: {
          isPublic: true,
          fullScreen: true,
          menu: false,
          ownCard: true,
        },
      },
      {
        path: '/recuperar-clave/confirmar',
        name: 'Nueva Clave',
        component: () => import('@/components/auth/NuevaClave.vue'),
        meta: {
          isPublic: true,
          fullScreen: true,
          menu: false,
          ownCard: true,
        },
      },
    ],
  },

  // Dashboard
  {
    path: '/',
    name: 'Dashboard',
    component: Dashboard,
    meta: {
      menu: true,
      roles: dashboardRoles,
    },
  },
  {
    path: '/resultados-filtros-dashboard',
    name: 'ResultadosFiltrosDashboard',
    component: FilteredResultsDashboard,
    meta: {
      menu: false,
    },
  },
  // OT Backoffice - vistas para administrar ordenes de trabajo
  {
    path: '/crear-orden',
    name: 'Ingresar OT',
    component: CreateOTView,
    meta: {
      menu: true,
      roles: ['Administrativo', 'Gerencia', 'Bodega', 'Supervisor'],
    },
  },
  {
    path: '/editar-orden/:order_id',
    name: 'Editar OT',
    component: CreateOTView,
  },
  {
    path: '/listar-ordenes',
    name: 'Trabajo en curso',
    component: ListOTView,
    props: true,
    meta: {
      menu: true,
      roles: [
        'Administrativo',
        'Gerencia',
        'Bodega',
        'Supervisor',
        'Técnico',
        'Retail',
      ],
    },
  },
  {
    path: '/orden/:order_id/',
    name: 'Orden de Trabajo',
    component: ViewOTView,
    meta: {
      roles: ['Supervisor', 'Técnico', 'Gerencia', 'Bodega', 'Administrativo'],
      allowRefresh: true,
    },
  },
  {
    path: '/orden/:order_id/venta-center',
    name: 'CheckoutVentaCenter',
    component: () => import('@/views/OTBackoffice/CheckoutVentaCenter.vue'),
    meta: {
      roles: ['Administrativo', 'Supervisor', 'Gerencia'],
    },
  },
  {
    path: '/orden/:order_id/pedir-partes',
    name: 'PedirPartes',
    component: AskParts,
    meta: {
      roles: ['Supervisor', 'Técnico', 'Gerencia', 'Bodega'],
    },
  },
  {
    path: '/orden/:order_id/repuestos-pedidos',
    name: 'RespuestosPedidos',
    component: RequestedPartsView,
    meta: {
      roles: ['Administrativo', 'Supervisor', 'Técnico', 'Gerencia', 'Bodega'],
    },
  },
  {
    path: '/excepciones/ot/:otId',
    name: 'Excepciones para ot',
    component: ExcepcionesView,
    meta: {
      roles: ['Administrativo', 'Supervisor', 'Técnico', 'Gerencia', 'Bodega'],
    },
  },
  {
    path: '/crear-orden-preingreso/:otId',
    name: 'Completar Preingreso',
    component: CreateOTView,
    meta: {
      roles: ['Administrativo'],
    },
  },
  // Excepciones
  {
    path: '/excepciones',
    name: 'Excepciones OT',
    component: ExcepcionesView,
    meta: {
      menu: false,
      LinkDropExcepciones: true,
      roles: ['Administrativo', 'Supervisor', 'Gerencia', 'Bodega'],
    },
  },
  {
    path: '/excepciones-ov',
    name: 'Excepciones OV',
    component: ExceptionsOV,
    meta: {
      menu: false,
      LinkDropExcepciones: true,
      roles: ['Administrativo', 'Supervisor', 'Gerencia', 'Bodega'],
    },
  },
  // Cotizaciones internas
  /* {
    path: '/cotizacionesInterna',
    name: 'Cotizaciones Internas',
    component: QuotationsView,
    meta: {
      menu: false,
      LinkDropPresupuestos: true,
      roles: ['Administrativo', 'Supervisor', 'Gerencia', 'Bodega'],
    },
  }, */
  // Cotizaciones externas
  /* {
    path: '/cotizaciones-externas',
    name: 'Cotizaciones Externas',
    component: ExternalQuotesView,
    meta: {
      menu: false,
      LinkDropPresupuestos: true,
      roles: ['Administrativo', 'Supervisor', 'Gerencia', 'Bodega'],
    },
  }, */
  // Oportunidad de venta
  {
    path: '/oportunidad-venta',
    name: 'Oportunidad de ventas',
    component: SalesOpportunityView,
    meta: {
      menu: false,
      LinkDropPresupuestos: false,
      LinkDropVentas: true,
      dropLabel: 'OV Repuestos y servicios',
      roles: ['Administrativo', 'Supervisor', 'Gerencia', 'Bodega'],
    },
  },
  // Oportunidad de venta de Equipos (OVE)
  {
    path: '/oportunidad-venta-equipo',
    name: 'Venta de Equipos',
    component: () => import('@/views/OVEBackoffice/ListOVEView.vue'),
    meta: {
      menu: false,
      LinkDropPresupuestos: false,
      LinkDropVentas: true,
      dropLabel: 'OV Equipos',
      roles: ['Administrativo', 'Gerencia', 'Ventas'],
    },
  },
  {
    path: '/oportunidad-venta-equipo/nueva',
    name: 'Crear OVE',
    component: () => import('@/views/OVEBackoffice/CreateOVEView.vue'),
    meta: {
      roles: ['Administrativo', 'Supervisor', 'Gerencia', 'Ventas'],
    },
  },
  {
    path: '/oportunidad-venta-equipo/:ove_id',
    name: 'OVEDetailView',
    component: () => import('@/views/OVEBackoffice/OVEDetailView.vue'),
    meta: {
      roles: ['Administrativo', 'Supervisor', 'Gerencia', 'Ventas'],
      allowRefresh: true,
    },
  },
  {
    path: '/oportunidad-venta-equipo/:ove_id/editar',
    name: 'EditOVE',
    component: () => import('@/views/OVEBackoffice/CreateOVEView.vue'),
    props: true,
    meta: {
      roles: ['Administrativo', 'Supervisor', 'Gerencia', 'Ventas'],
    },
  },
  {
    path: '/oportunidad-venta-equipo/:ove_id/pagar',
    name: 'OVEPaymentView',
    component: () => import('@/views/OVEBackoffice/OVEPaymentView.vue'),
    meta: {
      roles: ['Administrativo', 'Supervisor', 'Gerencia', 'Ventas'],
    },
  },
  // Pedidos de la Tienda (Samtek Center)
  {
    path: '/pedidos-tienda',
    name: 'Pedidos de la Tienda',
    component: () =>
      import('@/views/PedidosTiendaBackoffice/PedidosTiendaListView.vue'),
    meta: {
      menu: false,
      LinkDropPedidos: true,
      dropLabel: 'Pedidos de la tienda',
      roles: ['Administrativo', 'Supervisor'],
    },
  },
  {
    path: '/pedidos-tienda/:pedido_id',
    name: 'PedidoTiendaDetalle',
    component: () =>
      import('@/views/PedidosTiendaBackoffice/PedidosTiendaDetailView.vue'),
    meta: {
      roles: ['Administrativo', 'Supervisor'],
      allowRefresh: true,
    },
  },
  {
    path: '/pedidos-repuestos',
    name: 'Pedidos de la Tienda Repuestos',
    component: () =>
      import('@/views/PedidosRepuestosBackoffice/PedidosRepuestosListView.vue'),
    meta: {
      menu: false,
      LinkDropPedidos: true,
      dropLabel: 'Pedidos de la tienda Repuestos',
      roles: ['Administrativo', 'Supervisor'],
    },
  },
  {
    path: '/pedidos-repuestos/:pedido_id',
    name: 'PedidoRepuestoDetalle',
    component: () =>
      import(
        '@/views/PedidosRepuestosBackoffice/PedidosRepuestosDetailView.vue'
      ),
    meta: {
      roles: ['Administrativo', 'Supervisor'],
      allowRefresh: true,
    },
  },
  {
    path: '/oportunidad-venta/:ov_id',
    name: 'OVDetailView',
    component: OVDetailView,
    meta: {
      roles: ['Administrativo', 'Supervisor', 'Gerencia', 'Bodega'],
      allowRefresh: true,
    },
  },
  {
    path: '/oportunidad-venta/:id/revisar-cotizacion',
    name: 'RevisarCotizacionView',
    component: () => import('@/views/OVBackoffice/RevisarCotizacionView.vue'),
    meta: {
      roles: ['Administrativo', 'Supervisor', 'Gerencia', 'Bodega'],
      allowRefresh: true,
    },
  },
  {
    path: '/ingresar-presupuesto',
    name: 'Ingresar Presupuesto',
    component: AddQuoteClientView,
    meta: {
      LinkDropPublic: true,
      isPublic: true,
      fullScreen: true,
      menu: false,
    },
  },
  {
    path: '/ingresar-oportunidad',
    name: 'Ingresar Oportunidad',
    component: AddOportunityClientView,
    meta: {
      LinkDropPublic: true,
      isPublic: true,
      fullScreen: true,
      menu: false,
    },
  },
  // ClientOT
  {
    path: '/cliente',
    name: 'ClienteOT-login',
    component: ClientOTView,
    meta: {
      LinkDropPublic: true, // define si va en la lista Links Clientes
      isPublic: true,
      fullScreen: true,
      menu: false, // define si va en menú lateral
    },
  },
  {
    path: '/cliente/:otId/rut/:rut',
    name: 'ClienteOT',
    component: ClientOT,
    meta: {
      fullScreen: true,
      menu: false, // define si va en menú lateral
      isPublic: true,
    },
  },
  // Resultado de pago para OT
  {
    path: '/ot/:otId/:rut/resultado-pago',
    name: 'ResultadoPagoOT',
    component: ResultadoPagoOT,
    meta: {
      fullScreen: true,
      menu: false,
      isPublic: true,
    },
  },
  {
    path: '/orden/confirmar_cambio_retiro/:token',
    name: 'ConfirmChange',
    component: ConfirmChange,
    meta: {
      LinkDropPublic: false, // define si va en la lista Links Clientes
      fullScreen: true,
      menu: false, // define si va en menú lateral
      isPublic: true,
    },
  },
  // SILL-1533 (CUEST02.2) — Cuestionario de falla del equipo. Ruta pública: el
  // cliente llega desde el link del correo y lo único que la protege es el token.
  {
    path: '/formulario-falla/:token',
    name: 'formulario-falla',
    component: () => import('@/views/FormularioFalla/FormularioFallaView.vue'),
    meta: { isPublic: true, fullScreen: true, menu: false },
  },
  // Garantías extendidas OVG
  {
    path: '/garantias',
    name: 'ovg-landing',
    component: () => import('@/views/OVGStore/LandingView.vue'),
    meta: { isPublic: true, fullScreen: true, menu: false },
  },
  {
    path: '/garantias/cliente',
    name: 'ovg-cliente',
    component: () => import('@/views/OVGStore/ClienteFormView.vue'),
    meta: { isPublic: true, fullScreen: true, menu: false },
  },
  {
    path: '/garantias/modelo',
    name: 'ovg-modelo',
    component: () => import('@/views/OVGStore/ModeloSearchView.vue'),
    meta: { isPublic: true, fullScreen: true, menu: false },
  },
  {
    path: '/garantias/catalogo',
    name: 'ovg-catalogo',
    component: () => import('@/views/OVGStore/CatalogoView.vue'),
    meta: { isPublic: true, fullScreen: true, menu: false },
  },
  {
    path: '/garantias/protecciones',
    name: 'ovg-protecciones',
    component: () => import('@/views/OVGStore/ProteccionesView.vue'),
    meta: { isPublic: true, fullScreen: true, menu: false },
  },
  {
    path: '/garantias/carrito',
    name: 'ovg-carrito',
    component: () => import('@/views/OVGStore/CarritoView.vue'),
    meta: { isPublic: true, fullScreen: true, menu: false },
  },
  {
    path: '/garantias/pago/:token',
    name: 'ovg-pago',
    component: () => import('@/views/OVGStore/PagoView.vue'),
    meta: { isPublic: true, fullScreen: true, menu: false },
  },
  {
    path: '/garantias/resultado',
    name: 'ovg-resultado',
    component: () => import('@/views/OVGStore/ResultadoPagoView.vue'),
    meta: { isPublic: true, fullScreen: true, menu: false },
  },
  // Garantías center (backoffice)
  {
    path: '/garantias-center',
    name: 'OVGList',
    component: () => import('@/views/OVGBackoffice/OVGListView.vue'),
    meta: {
      menu: false,
      LinkDropVentas: true,
      dropLabel: 'OV Extensiones de garantía',
      roles: [],
    },
  },
  {
    path: '/garantias-center/crear',
    name: 'OVGCreate',
    component: () => import('@/views/OVGBackoffice/OVGCreateView.vue'),
    meta: { menu: false },
  },
  {
    path: '/garantias-center/:id',
    name: 'OVGDetail',
    component: () => import('@/views/OVGBackoffice/OVGDetailView.vue'),
    meta: { menu: false },
  },
  // Pre ingreso
  {
    path: '/pre-ingreso',
    name: 'Pre-Ingreso Retiro',
    component: Preingreso,
    meta: {
      LinkDropPublic: true,
      isPublic: true,
      fullScreen: true,
      menu: false, // define si va en menú lateral
    },
  },
  {
    path: '/pre-ingreso-regiones',
    name: 'Pre-Ingreso Envío',
    component: PreIngressRegions,
    meta: {
      LinkDropPublic: true,
      isPublic: true,
      fullScreen: true,
      menu: false, // define si va en menú lateral
    },
  },
  // Inventario
  {
    path: '/inventario',
    name: 'Control de Inventario',
    component: InventarioView,
    meta: {
      menu: false,
      LinkDropInv: true,
      roles: ['Administrativo', 'Supervisor', 'Gerencia', 'Bodega'],
    },
  },
  {
    path: '/movimientos-manuales',
    name: 'Movimientos Manuales',
    component: MovimientosManualesView,
    meta: {
      menu: false,
      LinkDropInv: true,
      roles: ['Administrativo', 'Supervisor', 'Gerencia', 'Bodega'],
    },
  },
  {
    path: '/partes',
    name: 'Mantenedor partes',
    component: Parts,
    meta: {
      menu: false,
      LinkDropInv: true,
      roles: ['Administrativo', 'Supervisor', 'Gerencia', 'Bodega'],
    },
  },
  {
    path: '/inventario/historial-pieza/:partNumber/:id',
    name: 'Historial de pieza',
    component: HistorialPiezaView,
    meta: {
      menu: false,
      roles: ['Administrativo', 'Supervisor', 'Gerencia', 'Bodega'],
    },
  },
  {
    path: '/inventario/ingreso-inventario/:tipo',
    name: 'Ingreso de inventario',
    component: IngresoInventarioView,
    meta: {
      menu: false,
      roles: ['Administrativo', 'Supervisor', 'Gerencia', 'Bodega'],
    },
  },

  // Reportes
  {
    path: '/reports/summary',
    name: 'Reporte Resumen',
    component: SummaryReport,
    meta: {
      menu: false,
      LinkDropReport: true,
    },
  },
  {
    path: '/reports/user',
    name: 'Reporte Usuarios',
    component: UserReport,
    meta: {
      menu: false,
      LinkDropReport: true,
    },
  },

  // Campañas de Correo
  {
    path: '/campaign',
    name: 'Campañas',
    component: () => import('@/views/Campaign/CampaignList.vue'),
    meta: {
      menu: false,
      LinkDropCampaign: true,
      dropLabel: 'Campañas de marketing',
      roles: ['Ventas', 'Gerencia'],
    },
  },
  {
    path: '/campaign/nuevo',
    name: 'campaign-create',
    component: () => import('@/views/Campaign/CampaignForm.vue'),
    meta: {
      menu: false,
      roles: ['Ventas', 'Gerencia'],
    },
  },
  {
    path: '/campaign/:id/editar',
    name: 'campaign-edit',
    component: () => import('@/views/Campaign/CampaignForm.vue'),
    meta: {
      menu: false,
      roles: ['Ventas', 'Gerencia'],
    },
  },
  {
    path: '/campaign/:id/metricas',
    name: 'campaign-metrics',
    component: () => import('@/views/Campaign/CampaignMetrics.vue'),
    meta: {
      menu: false,
      roles: ['Ventas', 'Gerencia'],
    },
  },

  // Campañas Instantáneas
  {
    path: '/instant-campaign',
    name: 'instant-campaign-list',
    component: () => import('@/views/Campaign/InstantCampaignList.vue'),
    meta: {
      menu: false,
      LinkDropCampaign: true,
      dropLabel: 'Campañas instantáneas',
      roles: ['Ventas', 'Gerencia'],
    },
  },
  {
    path: '/instant-campaign/nueva',
    name: 'instant-campaign-create',
    component: () => import('@/views/Campaign/InstantCampaignForm.vue'),
    meta: {
      menu: false,
      roles: ['Ventas', 'Gerencia'],
    },
  },
  {
    path: '/instant-campaign/:id/metricas',
    name: 'instant-campaign-metrics',
    component: () => import('@/views/Campaign/InstantCampaignMetrics.vue'),
    meta: {
      menu: false,
      roles: ['Ventas', 'Gerencia'],
    },
  },

  // Catch-all: página no encontrada (DEBE ser la última ruta)
  {
    path: '*',
    name: 'NotFound',
    component: () => import('@/components/Shared/NotFound.vue'),
    meta: {
      menu: false,
    },
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

const restoreUserFromLocalStorage = () => {
  console.log('restoreUserFromLocalStorage')
  const storedUser = JSON.parse(window.localStorage.getItem('user'))
  if (storedUser && storedUser.user.email) {
    store.commit('AuthenticationStore/SET_USER', { user: storedUser })
  }
}

router.beforeEach((to, from, next) => {
  if (from.name == null) restoreUserFromLocalStorage()
  const user = store.getters['AuthenticationStore/user']
  const { isPublic, roles } = to.meta

  // En el dominio de extensiones solo se exponen las rutas publicas (tienda
  // de garantias OVG). Cualquier ruta de Center se redirige a la tienda.
  if (window.location.hostname === 'extensiones.samtek.cl' && !isPublic) {
    return next({ path: '/garantias' })
  }

  const hasPerm = checkRoles({ roles, user })

  if (isPublic) {
    /** Vista Login y usuario autenticado: Se redirecciona al Dashboard */
    if (user && to.name === 'Login') {
      return next({ name: 'Dashboard' })
    }

    /** Vista privada y usuario NO autenticado: Se redirecciona al Login */
  } else if (!user) {
    return next({ name: 'Login' })

    /** Usuario sin permisos para acceder a la ruta */
  } else if (!hasPerm) {
    try {
      if (!checkRoles({ roles: dashboardRoles, user })) {
        return next({ name: 'Trabajo en curso' })
      }
      return next({ name: 'Dashboard' })
    } catch (err) {
      console.log('catched', err)
    }
  }
  next()
})

export default router
